import type { ReactNode } from 'react';
import { cn } from '../../utils/cn';
import styles from './FormSection.module.css';

export interface FormSectionProps {
  title?: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function FormSection({ title, description, icon, children, className }: FormSectionProps) {
  return (
    <section className={cn(styles.section, className)}>
      {title !== undefined ? (
        <h3 className={styles.heading}>
          {icon}
          {title}
        </h3>
      ) : null}
      {description ? <p className={styles.description}>{description}</p> : null}
      {children}
    </section>
  );
}
